import axios from 'axios';
import cookie from 'js-cookie';
import baseURL from './api-url.config';

const { ssoUserName, authToken } = cookie.get();
const headers = ssoUserName && authToken ? {
  'x-ssousername': decodeURIComponent(ssoUserName),
  'x-authtoken': decodeURIComponent(authToken)
} : {};

const API = axios.create({
  baseURL,
  headers: {
    common: headers
  }
});

export default API;